<template>
  <div class="vcv-not-found">
    <header-view />

    <div class="vcv-not-found__content">
      <img class="vcv-not-found__img" src="/static/images/404.svg" alt="Page not found" />

      <div class="vcv-not-found__text-wrapper">
        <div class="vcv-not-found__text-header">404</div>

        <div class="vcv-not-found__text">{{ notFoundText }}</div>
      </div>
    </div>
  </div>
</template>

<script>
import HeaderView from '@/components/header/Scene.vue';
import { mapState } from 'vuex';

export default {
  components: {
    HeaderView
  },

  computed: {
    ...mapState('global', ['error']),

    notFoundText() {
      if (this.error === 'Response not found') {
        return this.$tr('notfound.response-not-found');
      }

      return this.$tr('notfound.common');
    }
  }
};
</script>

<style lang="scss" scoped>
@import '@/styles/fonts.scss';

.vcv-not-found {
  height: 100%;

  &__content {
    height: 100%;
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;

    @media screen and (max-width: 900px) {
      flex-direction: column;
    }
  }

  &__img {
    margin-right: 4em;

    @media screen and (max-width: 900px) {
      margin-bottom: 2em;
      margin-right: 0;
      width: 120px;
      height: auto;
    }
  }

  &__text-wrapper {
    display: flex;
    flex-direction: column;
    max-width: 320px;
  }

  &__text-header {
    color: $main-dark;
    font-size: 8em;
    font-weight: 600;

    @media screen and (max-width: 900px) {
      font-size: 5em;
      text-align: center;
    }
  }

  &__text {
    @include mixin-text-header;

    @media screen and (max-width: 900px) {
      text-align: center;
    }
  }
}
</style>
